import { css, useTheme } from '@emotion/react';
import { Inline, Link, ResiLogoBanner, Text, useBreakpoint } from '@resi-media/resi-ui';
import { useFeed } from '@sites/contexts/feedContext';
import { usePrefix } from '@studio/hooks/use-prefix';
import { SearchInput } from '../SearchInput';
import { S } from './styles';

type _Props = {
  isMobileAndSearchOpen: boolean;
  isNotFoundPage?: boolean;
  siteName?: string;
};

const Header = ({ isMobileAndSearchOpen, isNotFoundPage, siteName }: _Props) => {
  const { commonT, linkT, prefixNS } = usePrefix('components:', 'appHeader');
  const theme = useTheme();
  const mediaQuery = useBreakpoint();
  const { playlists } = useFeed();

  return (
    <header css={(css) => S.header(css, isMobileAndSearchOpen)} data-testid="app-header">
      {!isMobileAndSearchOpen && (
        <Text css={css({ color: theme.palette.text.title, flexShrink: 0 })} dataTestId="app-header__site-name" truncate>
          {siteName}
        </Text>
      )}
      <Inline alignItems="center" gap="m" {...(isMobileAndSearchOpen && { width: 'full' })}>
        {!isNotFoundPage && Boolean(playlists?.length) && (
          <Inline
            alignItems="center"
            dataTestId="app-header__input-wrapper"
            justifyContent="flex-end"
            {...(isMobileAndSearchOpen && { gap: 'x0', width: 'full' })}
            {...(mediaQuery.lg && { width: '385px' })}
          >
            <SearchInput />
          </Inline>
        )}
        {mediaQuery.lg && !isMobileAndSearchOpen && (
          <Inline alignItems="center" color="contrast" flexShrink={1} justifyContent="flex-end" minWidth={0}>
            {mediaQuery.xl && (
              <Text dataTestId="powered-by-text" whiteSpace="nowrap">
                {commonT('poweredBy').toLowerCase()}
              </Text>
            )}
            <Link
              aria-label={prefixNS('ariaLabel')}
              colorVariant="inherit"
              css={css({
                transition: 'transform 100ms ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                },
              })}
              data-testid="resi-logo-link"
              href={linkT('resi')}
              rel="noopener noreferrer"
              target="_blank"
            >
              <ResiLogoBanner color={theme.palette.contrast} fontSize={theme.typography.pxToRem(61)} />
            </Link>
          </Inline>
        )}
      </Inline>
    </header>
  );
};

Header.displayName = 'Header';

export { Header };
